
























































































import Vue from 'vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import ProjectReprintQR from '@/components/project/ProjectReprintQR.vue'
import ProjectReprintAccountingRecords from '@/components/project/ProjectReprintAccountingRecords.vue'
import ProjectReprintHeaderFooterText from '@/components/project/ProjectReprintHeaderFooterText.vue'
import ProjectReprintReceiptData from '@/components/project/ProjectReprintReceiptData.vue'
import ProjectReprintArchive from '@/components/project/ProjectReprintArchive.vue'
import {
  GET_PROJECT_RECEIPT_LIST,
  GET_PROJECT_REPRINT_LIST, PROJECT_PREVIEW,
  PROJECT_REPRINT,
  PROJECT_REPRINT_CANCEL
} from '@/store/action-types'
import { ProjectReceipt } from '@/model/project/ProjectReceipt'
import {
  GetProjectReceiptsResponse,
  ProjectReprintCancelResponse,
  ProjectReprintResponse,
  ReprintListResponse
} from '@/types/service-response'
import moment from 'moment'
import { ProjectReprintList } from '@/model/project/ProjectReprintList'
import { ProjectReprintPayload } from '@/types/payload'
import { TranslateResult } from 'vue-i18n'
import { SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import WarningDialog from '@/components/WarningDialog.vue'
import * as securityService from '@/services/security-service'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  showWarningDialog: boolean
  reprintList: ProjectReprintList[]
  projectReceiptList: ProjectReceipt[]
  activeTab: number
  belegId: number | undefined

  printLoading: boolean
  searchLoading: boolean
  refreshLoading: boolean
  cancelLoading: boolean
}

export default Vue.extend({
  name: 'ProjectReprintAndCancellation',

  components: {
    ProjectReprintArchive,
    ProjectReprintReceiptData,
    ProjectReprintHeaderFooterText,
    ProjectReprintAccountingRecords,
    ProjectReprintQR,
    WarningDialog,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {
    projectId: Number
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      showWarningDialog: false,
      reprintList: [],
      projectReceiptList: [],
      activeTab: 0,
      belegId: undefined,

      printLoading: false,
      searchLoading: false,
      refreshLoading: false,
      cancelLoading: false
    }
  },

  watch: {
    projectId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.fetchData()
      }
    },

    activeTab (newVal: number): void {
      if(newVal !== 0) {
        this.refreshLoading = false
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    showReceiptExport (): boolean {
      return securityService.isVisible(SecurityArea.Projects, SecurityComponent.ProjectsReceiptExport)
    },

    disableReceiptExport (): boolean {
      return securityService.isDisabled(SecurityArea.Projects, SecurityComponent.ProjectsReceiptExport)
    },

    showEmailReceiptDelivery (): boolean {
      return securityService.isVisible(SecurityArea.Projects, SecurityComponent.ProjectsEmailReceiptDelivery)
    },

    disableEmailReceiptDelivery (): boolean {
      return securityService.isDisabled(SecurityArea.Projects, SecurityComponent.ProjectsEmailReceiptDelivery)
    },
  },

  methods: {
    formatDate (date: string): string {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },

    onPrintClick (item: ProjectReprintList): void {
      this.print(item)
    },

    onSearchClick (item: ProjectReprintList): void {
      this.preview(item)
    },

    onRefreshClick (): void {
      if(this.activeTab === 0) {
        this.refreshLoading = true
      }
    },

    onUndoClick (): void {
      this.showWarningDialog = true
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    onWarningDialogSave (): void {
      this.showWarningDialog = false
      this.cancel()
    },

    async print (item: ProjectReprintList): Promise<void> {
      if(this.belegId) {
        const payload: ProjectReprintPayload = {
          printStep: item.id,
          belegId: this.belegId,
          formular: item.formular
        }
        try {
          this.printLoading = true
          const response: ProjectReprintResponse = await this.$store.dispatch(PROJECT_REPRINT, payload)
          if (!response.IsError) {
            this.messageSnackbar = this.$t('project.projectReprint.printSuccessMessage')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            if(this.activeTab === 0) {
              this.refreshLoading = true
            }
          } else {
            this.messageSnackbar = this.$t('project.projectReprint.printErrorMessage')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('project.projectReprint.printErrorMessage')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } finally {
          this.printLoading = false
        }
      }
    },

    async preview (item: ProjectReprintList): Promise<void> {
      if(this.belegId) {
        const payload: ProjectReprintPayload = {
          printStep: item.id,
          belegId: this.belegId,
          formular: item.formular
        }
        try {
          this.searchLoading = true
          const data = await this.$store.dispatch(PROJECT_PREVIEW, payload)
          if (data && data.data) {
            let pdfData = new Blob([data.data], { type: 'application/pdf' })
            let fileURL = URL.createObjectURL(pdfData)
            window.open(fileURL, '_blank');
            this.messageSnackbar = this.$t('project.projectReprint.previewSuccessMessage')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
          } else {
            this.messageSnackbar = this.$t('project.projectReprint.previewErrorMessage')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('project.projectReprint.previewErrorMessage')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } finally {
          this.searchLoading = false
        }
      }
    },

    onRowClick (rowData: any): void {
      this.belegId = rowData.data.belegId
      this.fetchReprintList()
    },

    async cancel (): Promise<void> {
      if(this.belegId) {
        try {
          this.cancelLoading = true
          const response: ProjectReprintCancelResponse = await this.$store.dispatch(PROJECT_REPRINT_CANCEL, this.belegId)
          if (!response.IsError && response.Success) {
            this.messageSnackbar = this.$t('project.projectReprint.cancelSuccessMessage')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.belegId = undefined
            this.activeTab = 0
            this.fetchData()
          } else {
            this.messageSnackbar = this.$t('project.projectReprint.cancelErrorMessage')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.messageSnackbar = this.$t('project.projectReprint.cancelErrorMessage')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } finally {
          this.cancelLoading = false
        }
      }
    },

    async fetchData (): Promise<void> {
      try {
        const response: GetProjectReceiptsResponse = await this.$store.dispatch(GET_PROJECT_RECEIPT_LIST, this.projectId)
        if(!response.IsError && response.Receipts) {
          this.projectReceiptList = ProjectReceipt.createFromResponse(response.Receipts)
          if(this.projectReceiptList && this.projectReceiptList[this.projectReceiptList.length - 1]) {
            this.belegId = this.projectReceiptList[this.projectReceiptList.length - 1].belegId
            //@ts-ignore
            setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.belegId])}, 100)
            this.fetchReprintList()
          } else {
            this.belegId = undefined
            this.reprintList = []
          }
        } else {
          this.messageSnackbar =  this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchReprintList (): Promise<void> {
      try {
        const reprintListResponse: ReprintListResponse = await this.$store.dispatch(GET_PROJECT_REPRINT_LIST, this.belegId)
        if(!reprintListResponse.IsError && reprintListResponse.Data) {
          this.reprintList = ProjectReprintList.createFromResponse(reprintListResponse.Data)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }

  },

  mounted () {
    this.fetchData()
  }
})
